import { Component } from '@angular/core'

@Component({
    selector: 'app-calculator',
    templateUrl: './calculator.component.html',
    styleUrls: ['./calculator.component.css']
})
export class CalculatorComponent {
    show: boolean = false
    calculation: string = ''
    buttons: string[] = ['1', '2', '3', '+', '4', '5', '6', '-', '7', '8', '9', '*', 'C', '0', '=', '/']

    toggle() {
        this.show = !this.show
    }

    close() {
        this.show = false
    }

    onButtonClick(button: string) {
        if (button === 'C') {
            this.calculation = ''
        } else if (button === '=') {
            this.calculation = eval(this.calculation)
        } else {
            this.calculation += button
        }
    }
}
